import { api } from './'

export const updateUserSetting = (settingKey: string, value: Record<string, any>) =>
  api.put(`users/settings/${settingKey}`, { json: { settings: value } })
